import React, { useContext } from 'react'
import styled from 'styled-components'
import { FPS } from '../../../constants'
import { CreationToolsContext } from '../../../manager'
import getCurrentFrameCanvas from '../../../utils/get-current-frame-canvas'
import { StickerBlock } from '../../blocks'
import CreationCanvas from '../../canvas'

const Container = styled(StickerBlock as any)`
    width: 100%;
`

const Canvas = styled(CreationCanvas)`
    display: block;
    width: 100%;
`

const CreationUploadStickerPreview = () => {
    const { stepFrames } = useContext(CreationToolsContext)

    const draw = (canvas: HTMLCanvasElement, context: CanvasRenderingContext2D, drawCount: number) => {
        if (!stepFrames.length) return

        const frame = getCurrentFrameCanvas(stepFrames, drawCount)

        if (frame) {
            canvas.width = frame.width
            canvas.height = frame.height
            context.drawImage(frame, 0, 0)
        }
    }

    return (
        <Container>
            <Canvas draw={draw} fps={FPS} />
        </Container>
    )
}

export default CreationUploadStickerPreview
